var m = require('mithril');
var modalForm = require('../../layout/components/modalForm');
var datasetForm = modalForm(require('../../data/models/dataset'));
var containsForm = modalForm(require('../../dashboards/models/contains'));
var heading = require('../../components/heading');
var button = require('../../components/button');
var columnEditor = require('../components/columnEditor');
var addElementModal = require('../components/addElementModal');
var reportEventPanel = require('./reportEventPanel');
var eventBindings = require('../../../../../models/reports/eventBindings');
var loaders = require('../../layout/components/loaders');
var bulkAddPointsModal = require('./bulkAddPointsModal');

function saveExportGroup(dataset, value, parentCtrl) {
  var extendedProps = Object.assign({}, dataset.extendedProps || {}, {
    reportExportFile: String(value || '').trim()
  });
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/dataset/' + String(dataset['@rid']).replace(/^#/, ''),
    method: 'PUT',
    background: true,
    body: { extendedProps: extendedProps }
  }).then(function () {
    dataset.extendedProps = extendedProps;
    if (parentCtrl && typeof parentCtrl.init === 'function') return parentCtrl.init();
  });
}

module.exports = {view: function customReportBuildView(vnode) {
  var parentCtrl = vnode.attrs;
  var record = parentCtrl.record();
  var displayEdges = eventBindings.getReportContentContainsEdges(record);
  return m('div', [
  m(reportEventPanel, {record: record, showLocation: false}),
  m('div.overflow-hidden.mb3.mh3', [
    (function () {
      if (displayEdges.length > 0) {
        return m('div', displayEdges.map(function (containsEdge) {
          var dataset = containsEdge.in;
          containsEdge.name = containsEdge.in.name;
          return [
            m(heading, {label: dataset.name, class:'f2 '}, [
              m('div.flex.mb2', [
                m('div.ml2.ba.bw1.ph3.pv1.tc.v-btm.pointer', {
                  onclick: datasetForm.editDialogue.bind(datasetForm, dataset)
                }, [
                  m('i.f4.ion-ios-compose-outline.blue')
                ]),
                m('div.ml2.ba.bw1.ph3.pv1.tc.v-btm.pointer', {
                  onclick: containsForm.deleteDialogue.bind(containsForm, containsEdge)
                }, [
                  m('i.f4.ion-ios-trash.red')
                ])
              ])
            ]),
            m('div.flex.items-end.mb3', [
              m('label.flex-auto', [
                m('span.db.f6.moon-gray.mb1', 'Output file group'),
                m('input.w-100', {
                  type: 'text',
                  value: dataset.extendedProps && dataset.extendedProps.reportExportFile
                    ? dataset.extendedProps.reportExportFile
                    : record.name,
                  placeholder: 'Example: Level 2 zones',
                  onblur: function (event) {
                    saveExportGroup(dataset, event.target.value, parentCtrl);
                  }
                })
              ]),
              m(button, {
                label: 'Bulk Add Points',
                class: 'ml2 flex-none',
                func: function () {
                  return bulkAddPointsModal.editDialogue(record, dataset, {
                    onSaved: function (updatedReport) {
                      if (parentCtrl && typeof parentCtrl.record === 'function' && updatedReport) {
                        parentCtrl.record(updatedReport);
                      }
                      if (parentCtrl && typeof parentCtrl.init === 'function') return parentCtrl.init();
                    }
                  });
                }
              })
            ]),
            m('div.mt3', [
              m(columnEditor, {dataset, parentCtrl})
            ])
          ]
        }))
      }
    })(),
    ]),
    m('div.flex.justify-between.mh3', [
      m(button, {label: 'New Sheet', class: 'w-40 mr2', func: 
        datasetForm.editDialogue.bind(datasetForm, {parent: record['@rid']})}),
      m(button, {label: 'Add Sheet from Dashboards', class: 'w-40 ml2', func: 
        addElementModal.editDialogue.bind(addElementModal, record)})
    ])
  ])
}};
